export function parseUrl(pathname: string | null) {
  if (!pathname) {
    return {
      urlMusician: null,
      urlTitle: null,
      urlArrangement: null,
    };
  }
  const [urlMusician, urlTitle, urlArrangement] = pathname.split('/').slice(2, 5);

  return {
    urlMusician,
    urlTitle,
    urlArrangement,
  };
}
